import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSingleNeutralQuestion = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Regular",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 24 24",
	style: { enableBackground: "new 0 0 24 24" },
	xmlSpace: "preserve",
	fill: "#78818c",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", { d: "M5.25,7.5C3.182,7.5,1.5,5.818,1.5,3.75S3.182,0,5.25,0S9,1.682,9,3.75S7.318,7.5,5.25,7.5z M5.25,1.5 C4.009,1.5,3,2.509,3,3.75S4.009,6,5.25,6S7.5,4.991,7.5,3.75S6.491,1.5,5.25,1.5z" }),
		/* @__PURE__ */ _jsx("path", { d: "M3,24c-0.387,0-0.708-0.29-0.746-0.675L1.571,16.5H0.75C0.336,16.5,0,16.164,0,15.75v-3C0,9.855,2.355,7.5,5.25,7.5 s5.25,2.355,5.25,5.25v3c0,0.414-0.336,0.75-0.75,0.75H8.929l-0.682,6.825C8.208,23.71,7.887,24,7.5,24H3z M6.821,22.5l0.682-6.825 C7.542,15.29,7.863,15,8.25,15H9v-2.25C9,10.682,7.318,9,5.25,9S1.5,10.682,1.5,12.75V15h0.75c0.387,0,0.708,0.29,0.746,0.675 L3.679,22.5H6.821z" }),
		/* @__PURE__ */ _jsx("path", { d: "M17.25,13.5c-3.722,0-6.75-3.028-6.75-6.75S13.528,0,17.25,0S24,3.028,24,6.75S20.972,13.5,17.25,13.5z M17.25,1.5 C14.355,1.5,12,3.855,12,6.75S14.355,12,17.25,12s5.25-2.355,5.25-5.25S20.145,1.5,17.25,1.5z" }),
		/* @__PURE__ */ _jsx("path", { d: "M17.25,8.25c-0.414,0-0.75-0.336-0.75-0.75s0.336-0.75,0.75-0.75c0.62,0,1.125-0.505,1.125-1.125S17.87,4.5,17.25,4.5 s-1.125,0.505-1.125,1.125c0,0.414-0.336,0.75-0.75,0.75s-0.75-0.336-0.75-0.75C14.625,4.178,15.802,3,17.25,3 s2.625,1.178,2.625,2.625S18.698,8.25,17.25,8.25z" }),
		/* @__PURE__ */ _jsx("path", { d: "M17.25,11.25c-0.62,0-1.125-0.505-1.125-1.125c0-0.598,0.469-1.09,1.067-1.121c-0.001,0,0.003,0,0.004,0 c0.01-0.001,0.016-0.002,0.026-0.003c0,0-0.01,0-0.019,0.001C17.219,9.001,17.236,9,17.25,9c0.62,0,1.125,0.505,1.125,1.125 S17.87,11.25,17.25,11.25z" })
	] })]
});
const ForwardRef = forwardRef(SvgSingleNeutralQuestion);
export default ForwardRef;
